/**
 * Fills key-value pairs from object map into the given template string.
 * Fields are defined within curling brakets {}. The resulting string is
 * returned or an empty string if template
 * was not found.
 * 
 * @memberof vef.utils.template
 * 
 * @param {string} template 
 * @param {object} data 
 * 
 * @returns {string} resolved template
 */
export function resolveTemplate(template, data) {
    if (!template) throw Error('Template is not defined!');
    return template.replace(/{([a-z0-9]+)}/gi, (match, property) => {
        if (property in data) return data[property];
        return "";
    });
}